@if (cal) {
  <a [class]="aClass" [href]="cal.href || '#'" [attr.target]="openNewTab ? '_blank' : undefined" [style.order]="order">
    <mat-icon>open_in_new</mat-icon>
    <span>Sky Event Calendar | FM</span>
  </a>
}
